export default __webpack_public_path__ + "static/media/tempel-view.a8da937f.png";